interface Config {
    baseUrl: string;
}

let config: Config | null = null;

export const isDevelopment = import.meta.env.DEV;

export const loadConfig = async (): Promise<void> => {
    const response = await fetch('/config.json');
    config = await response.json();

    if (isDevelopment) {
        try {
            const devResponse = await fetch('/config.development.json');
            if (devResponse.ok) {
                const devConfig = await devResponse.json();
                config = { ...config, ...devConfig };
            }
        } catch {
            // config.development.json is optional
        }
    }
};

export const getBaseUrl = (): string => config?.baseUrl || '';
export const appVersion = import.meta.env.VITE_APP_VERSION || '';
